import { DialogContent, styled } from '@mui/material';

export const StyledDialogContent = styled(DialogContent)`
  overflow: scroll;
`;
